// Papel e permissões do usuário logado no painel (docs/seguranca/RBAC.md). A API é a autoridade (403);
// isto só decide o que mostrar (DESIGN §7.3).
import type { PapelEquipe, Permissao } from "@grindset/server/contratos";
import { useSessao } from "../../api/sessao";

export interface InfoPapel {
  papel: PapelEquipe;
  /** Tem a permissão (pacote do papel + ajustes individuais, calculado pela API). */
  pode: (permissao: Permissao) => boolean;
  /**
   * Atende alunos (atribuição `alunos.atender`, qualquer papel): padrões de tela ("Meus alunos", professor "eu" no
   * cadastro, filtro de professor escondido). Não é autorização.
   */
  orienta: boolean;
  usuarioId: string;
  nome: string;
  primeiroNome: string;
  academia: string;
  fuso: string;
}

const PAPEIS_EQUIPE: readonly PapelEquipe[] = [
  "PROFESSOR",
  "GERENTE",
  "MASTER",
  "PROFESSOR_LIDER",
  "RECEPCAO",
];

export function usePapel(): InfoPapel {
  const { data } = useSessao();
  const bruto = data?.usuario.papel;
  const papel: PapelEquipe = PAPEIS_EQUIPE.includes(bruto as PapelEquipe)
    ? (bruto as PapelEquipe)
    : "PROFESSOR";
  const permissoes = new Set<Permissao>(data?.usuario.permissoes ?? []);
  const nome = data?.usuario.nome ?? "";
  return {
    papel,
    pode: (p) => permissoes.has(p),
    orienta: permissoes.has("alunos.atender"),
    usuarioId: data?.usuario.id ?? "",
    nome,
    primeiroNome: nome.split(/\s+/)[0] ?? "",
    academia: data?.academia.nome ?? "",
    fuso: data?.academia.fuso ?? "America/Sao_Paulo",
  };
}
